import { useMemo } from 'react'

import { AvailableModules, Features } from 'generated/featureDefinitions'
import { GetFeatureAvailabilitiesDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'
import { isFeatureAvailabilityEnabled } from 'modules/core/lib/isFeatureAvailabilityEnabled'

export const useItManagementFeatureAvailability = () => {
  const { company } = useCurrentSession()

  const { data, loading, error } = useQuery(GetFeatureAvailabilitiesDocument, {
    fetchPolicy: 'cache-first',
    variables: {
      modules: [AvailableModules.it_management_v2],
      companyId: company.id,
    },
  })

  const featuresData = useMemo(() => data?.companies.featureAvailabilities ?? [], [data])

  const isItManagementEnabled = useMemo(
    () => isFeatureAvailabilityEnabled(featuresData, Features.it_management_v2_core),
    [featuresData]
  )

  const isDeviceCatalogEnabled = useMemo(
    () =>
      isItManagementEnabled &&
      isFeatureAvailabilityEnabled(featuresData, Features.it_management_v2_dev_device_catalog),
    [isItManagementEnabled, featuresData]
  )

  return {
    isItManagementEnabled,
    isDeviceCatalogEnabled,
    loading,
    error,
    featuresData,
  }
}
